/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdapterDownloadUrlResponse } from '../../models/adapter-download-url-response';

export interface StoresStoreIdAdapterDownloadUrlGet$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
}

export function storesStoreIdAdapterDownloadUrlGet(http: HttpClient, rootUrl: string, params: StoresStoreIdAdapterDownloadUrlGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AdapterDownloadUrlResponse>> {
  const rb = new RequestBuilder(rootUrl, storesStoreIdAdapterDownloadUrlGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdapterDownloadUrlResponse>;
    })
  );
}

storesStoreIdAdapterDownloadUrlGet.PATH = '/stores/{storeId}/adapter-download-url';
